'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Checkbox = require('material-ui/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props, context) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));

    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  _createClass(_class, [{
    key: 'onChange',
    value: function onChange(e, checked) {
      this.props.onChange(checked);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          value = _props.value,
          defaultChecked = _props.defaultChecked,
          defaultToggled = _props.defaultToggled,
          defaultValue = _props.defaultValue,
          others = _objectWithoutProperties(_props, ['onBlur', 'onChange', 'value', 'defaultChecked', 'defaultToggled', 'defaultValue']);

      return _react2.default.createElement(_Checkbox2.default, _extends({
        onCheck: this.onChange,
        checked: value
      }, others));
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  value: _react2.default.PropTypes.bool.isRequired,
  onChange: _react2.default.PropTypes.func.isRequired
};
_class.defaultProps = {
  onChange: function onChange(value) {
    return String(value);
  }
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/Checkbox/Checkbox.js
 ** module id = 488
 ** module chunks = 0
 **/